import Layout from 'components/Layout';
import { Route, Routes } from 'react-router-dom';
import GetStartedPage from './pages/GetStartedPage';
import GeneratedBrandbookPage from './pages/GeneratedBrandbookPage';
import { BrandBookContextProvider } from './context/index';
import ViewBrandbookPage from './pages/ViewBrandbookPage';

export default function Brandbook() {
  return (
    <Layout>
      <BrandBookContextProvider>
        <Routes>
          <Route path="/get-started" element={<GetStartedPage />} />
          <Route path="/result" element={<GeneratedBrandbookPage />} />
          <Route path="/view/:brandbook_id" element={<ViewBrandbookPage />} />
        </Routes>
      </BrandBookContextProvider>
    </Layout>
  );
}
